import { createAsyncThunk } from '@reduxjs/toolkit'
import { ErrorStore, Owner, OwnerBiometricWorkflowInfo } from '@types'
import { STORE_OWNERS, STORE_STATUS_INITIALIZED } from 'constants/store'
import {
  createGenericSlice,
  GenericState,
  createReducers,
  ExtraReducers,
} from 'stores/generics'
import { Payload } from 'stores'
import { PayloadAction } from '@reduxjs/toolkit'

export type OwnersState = {
  options: Owner[]
  selectedOwner: Owner | null
  ownerBiometricsLink: string
  ownerBiometricsDetails: OwnerBiometricWorkflowInfo | null
}

type State = GenericState<
  OwnersState,
  {
    data: OwnersState
    error_id: string
  }
>

export const initialState: State = {
  data: {
    options: [],
    selectedOwner: null,
    ownerBiometricsLink: '',
    ownerBiometricsDetails: null,
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchOwners = createAsyncThunk<
  OwnersState,
  Promise<OwnersState>,
  Payload
>(STORE_OWNERS, async (promise: Promise<OwnersState>, { rejectWithValue }) => {
  try {
    const response = await promise
    return response
  } catch (e: unknown) {
    const { code, message } = e as ErrorStore
    return rejectWithValue({ code, message, details: e })
  }
})

const extraReducers: ExtraReducers = createReducers<
  OwnersState,
  OwnersState,
  Payload
>(fetchOwners, initialState.data)

const ownersSlice = createGenericSlice({
  name: STORE_OWNERS,
  initialState,
  reducers: {
    setSelectedOwner: (state, action: PayloadAction<Owner | null>) => {
      state.data.selectedOwner = action.payload
    },
    setOwnerBiometricsLink: (state, action: PayloadAction<string>) => {
      state.data.ownerBiometricsLink = action.payload
    },
    setOwnerBiometricsDetails: (
      state,
      action: PayloadAction<OwnerBiometricWorkflowInfo | null>
    ) => {
      state.data.ownerBiometricsDetails = action.payload
    },
  },
  extraReducers,
})

const { actions, reducer } = ownersSlice

const { setSelectedOwner, setOwnerBiometricsLink, setOwnerBiometricsDetails } =
  actions

export { setSelectedOwner, setOwnerBiometricsLink, setOwnerBiometricsDetails }

export default reducer
